module.exports = __webpack_public_path__ + "static/media/DESTINATION.6ef3b918.svg";